import React from "react";

import { DeviceStatus } from "gql/generated/types";
import { Tag } from "primereact/tag";
import { ZonedDateTime } from "@js-joda/core";
import { DEFAULT_DATE_FORMATTER } from "utils/constants";

const DeviceStatusTag: React.FC<{ status: DeviceStatus; lastMeasurementDate?: string }> = ({
  status,
  lastMeasurementDate,
}) => {
  const formatLastMeasurementDate = lastMeasurementDate && ZonedDateTime.parse(lastMeasurementDate).format(DEFAULT_DATE_FORMATTER);
  const lastMeasDateString = `Last measurement: ${formatLastMeasurementDate}`
  switch (status) {
    case "OFFLINE":
      return <Tag value="Offline" severity="danger" title={lastMeasDateString} />;
    case "ONLINE":
      return <Tag value="Online" severity="success" title={lastMeasDateString} />;
    default:
      return <Tag value="No Data" severity="danger" title="No data" />;
  }
};

export default DeviceStatusTag;